import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the MortgageAccountsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class MortgageAccountsProvider {
  accounts: any = [];

  constructor(
    public http: Http,
    public events: Events,
    public gateway: GatewayClientProvider) {
  }

  getTransactions(customer_id) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getMortgageAccountTransactions(customer_id)
        .then((data) => {
          self.accounts = data;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }
  getAllDocuments(account_number) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getAllDocuments(account_number)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }
  getDocumentDownload(documentId) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getDocumentDownload(documentId)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  documentDownload(documentId: string) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.downloadDocument("/accounts/downloaddocuments", { documentsId: documentId, is_online: true })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  getOverpaymentValue(account_no) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getOverpaymentValue(account_no)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }
  getOverPaymentCalculate(data, account_no) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getOverPaymentCalculate(data, account_no)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }
  getRateChangeValue(account_no) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getRatechangeValue(account_no)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }
  getRateChangeCalculate(data, account_no) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getRateChangeCalculate(data, account_no)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  getRedemptionDetails(customer_id, accountno) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getRedemptionDetails(customer_id, accountno)
        .then((data) => {
          self.accounts = data;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  getMortgageRedemption(accountno) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getMortgageRedemption(accountno)
        .then((data) => {
          self.accounts = data;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }
  download_periodic_statements(downloadData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getmortgageaccountstatement(downloadData).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })

  }

  getRedemptionData(accountno) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getRedemptionData(accountno)
        .then((data) => {
          self.accounts = data;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  getrequestredemptionstatement(accountno) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getrequestredemptionstatement(accountno)
        .then((data) => {
          self.accounts = data;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  paymentValidation(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.paymentvalidation(data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  getpaymentslink(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getpaymentlink(data)
        .then((data) => {
          self.accounts = data;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  checkPayment(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.checkpayment(data)
        .then((data) => {
          self.accounts = data;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/mortgage-accounts/mortgage-accounts.ts